import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { parseBBCode } from "../_helpers";
import { SidebarCover, SidebarOptions, SidebarTimeline } from "./_components";
import { useMaps } from "../_contexts";
import { RelatedArticlesDisplay } from "../_components";
import bigInt from "big-integer";

export function SidebarLocationDetails({ marker }) {
  // console.log('SidebarLocationDetails', marker);
  const [locationEvents, setLocationEvents] = useState([]);
  const { items: events } = useSelector((state) => state.event);
  const { items: maps } = useSelector((state) => state.maps);
  const { goTo, goToMap, currentMap } = useMaps();

  useEffect(() => {
    const { parentMap, coords } = marker;
    let map = maps.find((m) => m._id === parentMap);
    const newCoords = {
      ...coords,
      z: map && map.options ? map.options.zoomMax : coords.z,
    };
    if (currentMap._id === parentMap) {
      // console.log("====Coords: ", map);
      goTo(newCoords);
    } else {
      goToMap(parentMap, newCoords);
    }
  }, [marker]);

  useEffect(() => {
    if (events && events.length > 0) {
      let filteredEvents = events
        .filter((event) => {
          if (event.marker && event.marker === marker._id) {
            return true;
          }
          return false;
        })
        .sort((eventA, eventB) => {
          return bigInt(eventA.fromDate).greater(eventB.fromDate) ? 1 : -1;
        });

      // console.log('Location Events', filteredEvents);
      setLocationEvents(filteredEvents);
    }
  }, [events, marker]);

  const descriptionClean = parseBBCode(marker.description);

  return (
    <div className="chronos-sidebar-content chronos-sidebar-location-details-wrapper">
      <SidebarCover name={marker.title} />
      <div className="chronos-sidebar-body">
        <div className="chronos-sidebar-type">
          <span>Location</span>
        </div>
        <h4 className="chronos-sidebar-title">{marker.title}</h4>
        <hr className="chronos-sidebar-separator" />

        {(!descriptionClean || descriptionClean.length === 0) && (
          <div className="chronos-sidebar-description">
            <h6 className="chronos-no-content text-muted text-center">
              No Information Available
            </h6>
          </div>
        )}

        <div
          className="chronos-sidebar-description"
          dangerouslySetInnerHTML={{ __html: descriptionClean }}
        ></div>
        {marker && marker.linkedArticles && marker.linkedArticles.length > 0 && (
          <React.Fragment>
            <RelatedArticlesDisplay articles={marker.linkedArticles} />
          </React.Fragment>
        )}
        {/* <SidebarLocationEvents events={locationEvents} /> */}
        <SidebarTimeline events={locationEvents} />
        <SidebarOptions item={marker} type="location" />
      </div>
    </div>
  );
}
